import { useSteps } from "react-step-builder";

import Rating from "../../components/rating/rating"

export default function StepDois(props) {
    const stepsState = useSteps();

    function onClickPreviousStep() {
        stepsState.prev()
    }

    function onChangeValue(value) {
        props.onChange('step2', value)
        stepsState.next()
    }

    return (
        <div className="centered-container animated" >
            <span className="step-title center">Obrigada por sua resposta!</span>
            <span className="subtitle left">Agora nos ajude a entender em quais aspectos podemos melhorar.</span>
            <span className="subtitle left"> Então, em uma escala de 0 a 10, que nota você daria ao <b><u>atendimento</u></b> em loja da Drogaria Catarinense?</span>

            <Rating value="1" onChange={onChangeValue} />

            <div className="step-form-actions">
                <span onClick={onClickPreviousStep}><img src="img/back_icon.png"></img> Voltar</span>
            </div>
        </div>
    )
}